import React from 'react';
import { Ban } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { fmtQ } from '@/components/po/PoLinePicker';
import { PoRowCard } from '@/components/po/SortPoRows';

/** A bundle's qty is more than what is pending on its PO row — pick a pending row that takes the whole bundle; none → the bundle is blocked. */
export const NextPoDialog = ({ ask, onPick, onCancel, onRemove }) => {
  if (!ask) return null;
  const { row, qty, left, options, what } = ask;
  const u = row.line.unit;
  const blocked = !options.length;
  return (
    <Dialog open onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-lg" data-testid="next-po-dialog" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle>{blocked ? 'Bundle blocked — no PO can take it' : 'Pick the next Purchase Order'}</DialogTitle>
          <DialogDescription data-testid="next-po-message">
            {what} has {fmtQ(qty)} {u} — only {fmtQ(left)} {u} is still pending on {row.po.po_number} ({row.line.supplier_design_name}).
            {blocked ? '' : ' The whole bundle is counted on the PO you pick, and the next bundles go there too.'}</DialogDescription></DialogHeader>
        {blocked ? (
          <div className="flex items-start gap-2 rounded-md border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800" data-testid="next-po-blocked">
            <Ban className="mt-0.5 h-4 w-4 shrink-0" />
            <span>No other open Purchase Order for this sort no has {fmtQ(qty)} {u} pending. This bundle can't be counted — check the qty, or ask Purchase to raise a new PO.</span>
          </div>
        ) : (
          <div className="max-h-[50vh] space-y-1.5 overflow-y-auto">
            {options.map((r) => <PoRowCard key={r.line.po_item_id} r={r} free={r.free} onPick={onPick} testId={`next-po-opt-${r.line.po_item_id}`} />)}
          </div>
        )}
        <DialogFooter className="gap-2">
          {blocked && onRemove && <Button variant="destructive" onClick={onRemove} data-testid="next-po-remove">Remove bundle</Button>}
          <Button variant="outline" onClick={onCancel} data-testid="next-po-cancel">{blocked ? 'Fix the qty' : 'Cancel'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NextPoDialog;
